(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mintfocus-product-showcase"] && !Shopify.designMode) return;
  try {
    
  const initializeMintFocusProduct = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    const planSelect = root.querySelector('[data-plan-select]');
    const subscriptionPrice = root.querySelector('[data-subscription-price]');
    const mainPrice = root.querySelector('[data-main-price]');
    const subscriptionExtra = root.querySelector('[data-subscription-extra]');
    const purchaseOptions = root.querySelectorAll('[data-purchase-option]');
    const quantityInput = root.querySelector('input[name="quantity"]');
    const minusButton = root.querySelector('[data-quantity-minus]');
    const plusButton = root.querySelector('[data-quantity-plus]');
    const variantSelect = root.querySelector('[data-variant-select]');
    const cartDrawerComponent = document.querySelector('cart-drawer-component');

    cartDrawerComponent?.setAttribute('auto-open', '');

    const syncPurchaseOption = () => {
      const selectedOption = root.querySelector('[data-purchase-option]:checked');
      const isSubscription = selectedOption?.value === 'subscription';
      purchaseOptions.forEach((option) => {
        option.closest('[data-purchase-card]')?.classList.toggle('is-selected', option.checked);
      });
      if (subscriptionExtra) subscriptionExtra.hidden = !isSubscription;
      const selectedPlan = planSelect?.options[planSelect.selectedIndex];
      const selectedPrice = isSubscription ? selectedPlan?.dataset.price : mainPrice?.dataset.oneTimePrice;
      if (mainPrice && selectedPrice) mainPrice.textContent = selectedPrice;
      if (!sellingPlanInput || !planSelect) return;
      sellingPlanInput.disabled = !isSubscription;
      sellingPlanInput.value = isSubscription ? planSelect.value : '';
    };

    purchaseOptions.forEach((option) => option.addEventListener('change', syncPurchaseOption));

    planSelect?.addEventListener('change', () => {
      const selectedPlan = planSelect.options[planSelect.selectedIndex];
      if (subscriptionPrice && selectedPlan?.dataset.price) {
        subscriptionPrice.textContent = selectedPlan.dataset.price;
      }
      syncPurchaseOption();
    });

    minusButton?.addEventListener('click', () => {
      const minimum = Number(quantityInput?.min || 1);
      const current = Number(quantityInput?.value || 1);
      if (quantityInput) quantityInput.value = Math.max(minimum, current - 1);
    });

    plusButton?.addEventListener('click', () => {
      const current = Number(quantityInput?.value || 1);
      if (quantityInput) quantityInput.value = current + 1;
    });

    variantSelect?.addEventListener('change', () => {
      const destination = new URL(variantSelect.dataset.productUrl, window.location.origin);
      destination.searchParams.set('variant', variantSelect.value);
      window.location.assign(destination.toString());
    });

    syncPurchaseOption();
  };

  const initializeAllMintFocusProducts = (scope = document) => {
    scope.querySelectorAll('[data-mintfocus-product]').forEach(initializeMintFocusProduct);
  };

  initializeAllMintFocusProducts();
  document.addEventListener('shopify:section:load', (event) => initializeAllMintFocusProducts(event.target));

  } catch(e) { console.error(e); }
})();
})();
